(window.FeaturedProductSlider = function (Behaviors) {

  "use strict";
  
  function FeaturedProductSlider(elem) {
    Behaviors.init(FeaturedProductSlider, this, arguments)

    this.fpsSlider = this.$elem[0];

    const fpsSlider = new Swiper(this.fpsSlider, {
      wrapperClass: 'fp__track',
      slideClass: 'fp__item',
      speed: 500,
      navigation: {
        nextEl: '.fp__control .chevron--right',
        prevEl: '.fp__control .chevron--left',
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 2,
          spaceBetween: 14,
          loop: true,
        },
        // when window width is >= 1025px
        1025: {
          slidesPerView: 'auto',
          spaceBetween: 12,
          loop: true,
        }
      }
    });
  }

  Behaviors.inherit(FeaturedProductSlider, Behaviors.Behavior);
  FeaturedProductSlider.QUERY = '.fp__slider';

  Behaviors.register_behavior(FeaturedProductSlider);
  
  return FeaturedProductSlider;

  }(window.Behaviors));